import { breakpoints } from "./breakpoints";

$ = jQuery;

(function ($) {

    $(function () {

        let isDesktop = window.innerWidth >= breakpoints.viewport_lg;
        let eventElement = isDesktop ? '.js-filterInspiration.m-sidebarFilters__input' : '.js-filterInspiration:not(.m-sidebarFilters__input)';
        let eventListener = isDesktop ? 'change' : 'click';
        const $dim = $(".js-dim");
        const MIN_LOADER_DURATION = 800;

        // Function to fetch filtered inspiration
        function fetchInspiration(data) {
            const startTime = Date.now();
            $('.js-inspirationItems').html('');
            $('.js-loaderElement').show();

            $.ajax({
                type: 'POST',
                url: ajax.url,
                data: {
                    action: 'filter_inspiration',
                    data: data
                },
                dataType: 'json',
                success: function(response) {
                    const elapsed = Date.now() - startTime;
                    const remainingDelay = Math.max(0, MIN_LOADER_DURATION - elapsed);

                    setTimeout(function() {
                        $('.js-loaderElement').hide();
                        if(response.success) {
                            const res = response.data;
                            $('.js-inspirationItems').html(res.content);
                            const countText = res.count === 1 ? 'resultaat gevonden' : 'resultaten gevonden';
                            $('.js-inspirationCount').html(`${res.count} ${countText}`);
                        } else {
                            $('.js-inspirationItems').html('<p class="o-archive__noResult">Geen resultaten gevonden.</p>');
                        }
                    }, remainingDelay);
                },
                error: function(xhr, status, error) {
                    console.log('AJAX Error:', error);
                }
            });
        }

        function getCheckedValues() {
            const checkedValues = [];
            $('.m-sidebarFilters__subList input:checked').each(function() {
                checkedValues.push($(this).val());
            });
            return checkedValues.length ? checkedValues : 'reset';
        }

        function getFilterData(page) {
            return {
                value: getCheckedValues(),
                post_type: 'inspiration',
                page: page || 1
            };
        }

        // Update URL query params so pagination/filter state is bookmarkable
        function updateUrl(data) {
            if (!window.history || !window.history.pushState) return;

            const url = new URL(window.location.href);
            const params = url.searchParams;

            const page = data.page || 1;
            // Use pretty pagination in the path: /page/{n}/
            // and keep query params for filters only (avoid /page/3/?paged=3 duplicates).
            url.pathname = url.pathname.replace(/\/page\/\d+\/?$/i, '/');
            url.pathname = url.pathname.replace(/\/page\/\d+\//i, '/');
            if (page > 1) {
                url.pathname = url.pathname.replace(/\/$/, '') + `/page/${page}/`;
            }
            // Ensure we don't keep paged in querystring.
            params.delete('paged');
            params.delete('page');

            if (data.value && data.value !== 'reset' && Array.isArray(data.value) && data.value.length) {
                params.set('filter', data.value.join(','));
            } else {
                params.delete('filter');
            }

            url.search = params.toString();
            window.history.pushState({}, '', url.toString());
        }

        function scrollPageToTop() {
            $('html, body').animate({ scrollTop: 0 }, 300);
        }

        // Trigger filter on checkbox change or click based on device
        $(eventElement).on(eventListener, function() {
            const data = getFilterData(1);
            updateUrl(data);
            $('.m-sidebarFilters').removeClass('-active');
            $('.t-archive__sidebar').removeClass('-filterActive');
            $('html, body').removeClass('-overflow');
            $dim.removeClass("-active");

            // Count checked input fields
            const subList = $(this).closest('.m-sidebarFilters__subList');
            const checkedCount = subList.find('input:checked').length;
            subList.parent().find('.js-filterCount').text(checkedCount);

            scrollPageToTop();

            fetchInspiration(data);
        });

        if( !isDesktop ) {

            // Count checked input fields on mobile
            $(document).on('click', '.js-filterInspiration.m-sidebarFilters__input', function() {

                const subList = $(this).closest('.m-sidebarFilters__subList');
                const checkedCount = subList.find('input:checked').length;
                subList.parent().find('.js-filterCount').text(checkedCount);

            });

        }

        $(document).on('click', '.js-toggleFilters', function(e) {
            $(this).closest('.m-sidebarFilters').toggleClass('-active');
            $(this).closest('.t-archive__sidebar').toggleClass('-filterActive');
            $('html, body').toggleClass('-overflow');
            $dim.toggleClass("-active");
        });
                
        $(document).on('click', '.js-dim', function(e) {
            $('.m-sidebarFilters').removeClass('-active');
            $('.t-archive__sidebar').removeClass('-filterActive');
            $('html, body').removeClass('-overflow');
            $('.js-openShare').removeClass('-active');
            $dim.removeClass("-active -share");
        });

        // AJAX pagination (links rendered inside .js-inspirationItems)
        $(document).on('click', '.js-inspirationItems .m-pagination a', function(e) {
            const $link = $(this);
            if ($link.hasClass('disabled') || $link.parent().hasClass('disabled')) return;

            let page = $link.data('page');
            if (page == null && $link.attr('href')) {
                const href = $link.attr('href');
                // Support both query-string pagination (?paged=2) and pretty permalinks (/page/2/)
                const matchQuery = href.match(/[?&]paged?=(\d+)/i);
                const matchPretty = href.match(/\/page\/(\d+)\/?/i);
                const match = matchQuery || matchPretty;
                page = match ? parseInt(match[1], 10) : null;

                // Page 1 often has no explicit /page/1/ or ?paged=1 (it links to the base URL).
                // In that case, fall back to link text if it's numeric.
                if (page == null) {
                    const textNum = parseInt(($link.text() || '').trim(), 10);
                    if (!Number.isNaN(textNum) && textNum > 0) {
                        page = textNum;
                    }
                }
            }
            if (page == null) {
                // If we can't determine the page number, let the browser handle the link normally.
                return;
            }

            e.preventDefault();

            const data = getFilterData(page);
            updateUrl(data);
            fetchInspiration(data);

            scrollPageToTop();
        });

        // Initialize filter/page from URL on load
        (function initFromUrl() {
            const url = new URL(window.location.href);
            const params = url.searchParams;
            // Prefer pretty pagination /page/{n}/, fallback to query params.
            const matchPretty = url.pathname.match(/\/page\/(\d+)\/?$/i);
            const pageParam = (matchPretty && matchPretty[1]) ? matchPretty[1] : (params.get('paged') || params.get('page'));
            const initialPage = pageParam ? parseInt(pageParam, 10) || 1 : 1;
            const filterVal = params.get('filter');

            let shouldRefetch = false;
            if (filterVal && filterVal !== 'reset') {
                const wanted = filterVal.split(',').filter(Boolean);
                if (wanted.length) {
                    $('.m-sidebarFilters__subList input').each(function() {
                        const $cb = $(this);
                        const val = ($cb.val() || '').toString();
                        $cb.prop('checked', wanted.includes(val));
                    });
                    shouldRefetch = true;
                }
            }

            if (initialPage > 1 || shouldRefetch) {
                fetchInspiration(getFilterData(initialPage));
            }
        })();

    });

})(jQuery);